import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ColDef } from 'ag-grid-community/dist/lib/entities/colDef';
import { Observable } from 'rxjs';

import {
  AggFunc,
  BarChartDatePeriod,
  BaseComponent,
  CustomerSalesOrderHistory,
  CustomerService,
  GridService,
} from 'tms-lib';

@Component({
  selector: 'app-customer-credit-sales-orders',
  templateUrl: './customer-credit-sales-orders.component.html',
  styleUrl: './customer-credit-sales-orders.component.scss',
})
export class CustomerCreditSalesOrdersComponent extends BaseComponent implements OnInit {
  model$: Observable<CustomerSalesOrderHistory[]>;

  @Input() customerId: string;
  @Input() liveOrders = false;

  header = $localize`Sales Orders`;

  columnDefs: ColDef[] = [
    this.gridService.text('orderNo', $localize`Order Number`),
    this.gridService.text('sequence', $localize`Line Number`),
    this.gridService.date('orderDate', $localize`Order Date`),
    this.gridService.text('customerOrderNo', $localize`Customer Order Number`),
    this.gridService.text('customerOrderRef', $localize`Customer Order Reference`),
    this.gridService.text('productKey', $localize`Product`),
    this.gridService.text('productDescription', $localize`Description`),
    this.gridService.text('productTypeDescription', $localize`Product Type`),
    this.gridService.text('currencyCode', $localize`Currency`),
    this.gridService.numberFormat('orderQuantity', $localize`Order Quantity`),
    this.gridService.numberFormat('orderPrice', $localize`Order Price`),
    this.gridService.numberFormat('orderValue', $localize`Order Value`),
    this.gridService.numberFormat('orderSterlingValue', $localize`Order Value (£)`, { aggFunc: AggFunc.sum }),
    this.gridService.text('orderStatus', $localize`Order Status`),
    this.gridService.text('despatchNoteNo', $localize`Despatch Note Number`),
    this.gridService.numberFormat('despatchQuantity', $localize`Despatch Quantity`),
    this.gridService.date('despatchDate', $localize`Despatch Date`),
    this.gridService.text('invoiceNo', $localize`Invoice Number`),
    this.gridService.date('invoiceDate', $localize`Invoice Date`),
    this.gridService.numberFormat('invoicePrice', $localize`Invoice Price`),
  ];

  barChartPeriod = BarChartDatePeriod.Year;

  constructor(
    private customerService: CustomerService,
    private gridService: GridService,
    private route: ActivatedRoute,
  ) {
    super();
  }

  ngOnInit() {
    if (!this.customerId) {
      this.customerId = this.route.snapshot.paramMap.get('id');
    }
    this.getModel();
  }

  private getModel() {
    this.model$ = this.customerService.getCustomerSalesOrderHistory(this.customerId, this.liveOrders, '');
    if (this.liveOrders) {
      this.header = (this.liveOrders ? $localize`Outstanding` + ' ' : '') + this.header;
    }
  }
}
